// Shared mapping from backend event action_type keys to user-facing labels.
// Consumed by AuditTimeline and ProjectActivityTimeline so both views render
// plain-language labels (not raw "document.retry_embedding" strings).

export const ACTION_LABELS: Record<string, string> = {
  'document.upload': 'Document uploaded',
  'document.embedding_complete': 'Embeddings completed',
  'document.download': 'Document downloaded',
  'document.update': 'Document updated',
  'document.delete': 'Document deleted',
  'document.retry_embedding': 'Reanalysis requested',
  'document.correction_submit': 'Correction submitted',
  'document.correction_edit': 'Correction edited',
  'permission.grant': 'Shared with user',
  'permission.update': 'Permission updated',
  'permission.revoke': 'Permission revoked',
  'document_list.add': 'Connection saved',
  'document_list.remove': 'Connection removed',
  'folder_list.add': 'Added to folder list',
  'folder_note.create': 'Note added',
  'novelty.request': 'Novelty analysis requested',
  'novelty.complete': 'Novelty analysis completed',
  'novelty.project_request': 'Project analysis requested',
  'novelty.project_complete': 'Project analysis completed',
  'project.create': 'Project created',
  'project.update': 'Project updated',
  'project.delete': 'Project deleted',
  'project.declaration_edited': 'Declaration edited',
  'project.reprocess_started': 'Reprocess started',
  // Story #6490 1.6 / 8.5 — written detail-less when a co-owner's personal key revoke
  // deletes their vectors in a shared project, so the other owners see why results shrank.
  'project.vectors.purged.personal-revoke': 'Search entries deleted — a co-owner revoked their encryption key',
}

export const ACTION_COLORS: Record<string, string> = {
  'document.upload': 'bg-iflow-400',
  'document.embedding_complete': 'bg-green-400',
  'document.download': 'bg-amber-400',
  'document.update': 'bg-blue-400',
  'document.delete': 'bg-red-400',
  'document.retry_embedding': 'bg-iflow-400',
  'document.correction_submit': 'bg-amber-400',
  'document.correction_edit': 'bg-amber-400',
  'permission.grant': 'bg-blue-400',
  'permission.update': 'bg-blue-400',
  'permission.revoke': 'bg-red-400',
  'document_list.add': 'bg-purple-400',
  'document_list.remove': 'bg-gray-400',
  'folder_list.add': 'bg-purple-400',
  'folder_note.create': 'bg-yellow-400',
  'novelty.request': 'bg-iflow-400',
  'novelty.complete': 'bg-green-400',
  'novelty.project_request': 'bg-iflow-400',
  'novelty.project_complete': 'bg-green-400',
  'project.create': 'bg-green-400',
  'project.update': 'bg-blue-400',
  'project.delete': 'bg-red-400',
  'project.declaration_edited': 'bg-iflow-400',
  'project.reprocess_started': 'bg-iflow-400',
  'project.vectors.purged.personal-revoke': 'bg-amber-400',
}

/**
 * Fallback humaniser for event action types that aren't in ACTION_LABELS.
 * Converts `namespace.action_name` to `Namespace: Action name`.
 */
export function humaniseActionType(actionType: string): string {
  if (!actionType) return ''
  const parts = actionType.split('.')
  if (parts.length !== 2) return actionType
  const [ns, action] = parts
  const nsTitle = ns.charAt(0).toUpperCase() + ns.slice(1)
  const actionText = action.split('_').join(' ')
  return `${nsTitle}: ${actionText}`
}
